import { render, staticRenderFns } from "./Ktlist.vue?vue&type=template&id=bf64fbf0&scoped=true&"
import script from "./Ktlist.vue?vue&type=script&lang=js&"
export * from "./Ktlist.vue?vue&type=script&lang=js&"
import style0 from "./Ktlist.vue?vue&type=style&index=0&id=bf64fbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf64fbf0",
  null
  
)

export default component.exports